module.exports = __webpack_public_path__ + "img/icb-co-Inte-m@3x.57102cb9.png";